import axios from "axios";

const uploadToS3 = async (payload) => {
  const { presignedUrl, fileToUpload, setProgress } = payload;
  try {
    const config = {
      headers: {
        "Content-Type": fileToUpload.type,
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const progressPercent = Math.round((progressEvent.loaded / progressEvent.total) * 100);

          if (setProgress) {
            setProgress(progressPercent);
          }
        }
      },
    };

    const response = await axios.put(presignedUrl, fileToUpload, config);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default uploadToS3;
